/* eslint-disable */
// prettier-ignore
export default {
  pages: {
    key: 'title',
    data: [
      { title: 'Dashboard', route: { name: 'dashboard' }, icon: 'ActivityIcon', isBookmarked: true },
      { title: 'Transactions', route: { name: 'transactions' }, icon: 'ListIcon', isBookmarked: false }
    ],
  },
}
/* eslint-enable */
